"use strict";

var LoggerInstance = require("js-logger").get("AccountCommunicationsHelper");

var AccountStore = require("./AccountStore");

var ActionsHelper = require("../actions/ActionsHelper");

var AccountApi = require("../api/AccountApi");

var Spinner = require("../client/Spinner");

var SubmitButtonHelper = require("../commonComponents/SubmitButtonHelper");

var ApiHelper = require("../shared/ApiHelper");
var InputHelper = require("../shared/InputHelper");
var LinkMessageHelper = require("../shared/LinkMessageHelper");
var ValidationHelper = require("../commonComponents/ValidationHelper");

var accountCommunicationFormComponentSelector = "[data-component='accountCommunicationForm']";

var propertySelector = "[data-component='textInput'][data-data-binding^='dataBinding-'] input," +
	"[data-component='textArea'][data-data-binding^='dataBinding-'] textarea";

var codeSelector = "[data-component='singleCheckbox'] input," +
	"[data-component='select'] select," +
	"[data-component='radioButtons.singleRadioButton'] input," +
	"[data-component='multipleCheckboxes.singleCheckbox'] input";

var dateSelector = "[data-component='textInput'][data-data-binding^='singleValueDate'] input," +
	"[data-component='textInput'][data-data-binding^='multiValueDate'] input," +
	"[data-component='textArea'][data-data-binding^='singleValueDate'] textarea," +
	"[data-component='textArea'][data-data-binding^='multiValueDate'] textarea";

var noteSelector = "[data-component='textInput'][data-data-binding^='note'] input," +
	"[data-component='textArea'][data-data-binding^='note'] textarea";

var numberSelector = "[data-component='textInput'][data-data-binding^='singleValueNumber'] input," +
	"[data-component='textInput'][data-data-binding^='multiValueNumber'] input," +
	"[data-component='textArea'][data-data-binding^='singleValueNumber'] textarea," +
	"[data-component='textArea'][data-data-binding^='multiValueNumber'] textarea";

var nonCheckableFieldsSelector = "[data-component='textInput'] input,textarea,select";

var checkableFormFieldsSelector = "[data-component='radioButtons.singleRadioButton.input']," +
	"[data-component='singleCheckbox.input']," +
	"[data-component='multipleCheckboxes.singleCheckbox.input']";

var AccountCommunicationsHelper = {
	createCommunication: function (event) {
		try {
			event = this._getEventOrReturn(event, LinkMessageHelper.linkMessageMapper("createCommunication"));

			if (!event) {
				return false;
			}

			var $accountCommunicationFormComponent = $(event.target).closest(accountCommunicationFormComponentSelector);

			Spinner.showSpinner($accountCommunicationFormComponent);

			var communication = this.serializeCommunicationForm($accountCommunicationFormComponent);
			var components = [
				$accountCommunicationFormComponent
			];

			ValidationHelper.validate({ components }).always(isValid => {
				if (!isValid) {
					Spinner.removeSpinner($accountCommunicationFormComponent);
					return;
				}

				AccountApi.createCommunication(communication)
				.done(() => {
					this.clearCommunicationForm($accountCommunicationFormComponent);

					SubmitButtonHelper.performPostSubmitAction(accountCommunicationFormComponentSelector);

					Spinner.removeSpinner($accountCommunicationFormComponent);
				})
				.fail(jqXHR => {
					if (jqXHR.status === 401) {
						Spinner.removeSpinner($accountCommunicationFormComponent);
						Spinner.showSpinner();
						window.location = "/login"
						return;
					}

					LoggerInstance.error(jqXHR);

					var errorMessage = $accountCommunicationFormComponent.attr("data-error-message");
					ApiHelper.displayErrorMessage(null, errorMessage);

					Spinner.removeSpinner($accountCommunicationFormComponent);
				});
			});
		} catch (exception) {
			LoggerInstance.error(exception);
			Spinner.removeSpinner($accountCommunicationFormComponent);
		} finally {
			return false;
		}
	},

	serializeCommunicationForm: function ($accountCommunicationFormComponent) {
		var properties = this.serializeProperties($accountCommunicationFormComponent);
		var codes = this.serializeCodes($accountCommunicationFormComponent);
		var dates = this.serializeDates($accountCommunicationFormComponent);
		var notes = this.serializeNotes($accountCommunicationFormComponent);
		var numbers = this.serializeNumbers($accountCommunicationFormComponent); 

		var communication = Object.assign(
			{},
			properties,
			{ codes },
			{ dates },
			{ notes },
			{ numbers }
		);

		return communication;
	},

	serializeProperties: function ($accountCommunicationFormComponent) {
		var propertiesArray = InputHelper.getGeneralInputValues(
			$accountCommunicationFormComponent.find(propertySelector)
		);

		var properties = {
			"type": $accountCommunicationFormComponent.attr("data-communication-type")
		};

		propertiesArray.forEach(property => {
			// Only assign properties that have values defined.
			if (Object.values(property)[0]) {
				Object.assign(properties, property);
			}
		});

		if (properties.shortComment && properties.shortComment.length > 70) {
			properties.shortComment = properties.shortComment.substring(0, 70);
		}

		return properties;
	},

	serializeCodes: function ($accountCommunicationFormComponent) {
		var codes = InputHelper.getGeneralInputValues(
			$accountCommunicationFormComponent.find(codeSelector)
		);

		return codes.filter(code => !!code.type && !!code.value && !code.isDeleted);
	},

	serializeDates: function ($accountCommunicationFormComponent) {
		var dates = InputHelper.getGeneralInputValues(
			$accountCommunicationFormComponent.find(dateSelector)
		);

		return dates.filter(date => !!date.type && !!date.value);
	},

	serializeNotes: function ($accountCommunicationFormComponent) {
		var notes = InputHelper.getGeneralInputValues(
			$accountCommunicationFormComponent.find(noteSelector)
		);

		notes.forEach(note => {
			if (note.shortComment && note.shortComment.length > 70) {
				note.shortComment = note.shortComment.substring(0, 70);
			}
		});

		return notes.filter(note => !!note.type && (!!note.shortComment || !!note.longComment));
	},

	initializeNumbers: function () {
		var $component = $(numberSelector);
		InputHelper.initializeIntegerInput({
			$component,
			defaultValue: null,
			greaterThanZero: false,
			numberSelector: $component,
			allowNegative: true
		});
	},

	initializeDates: function (dateFormat) {
		InputHelper.initializeDates({
			$component: $(accountCommunicationFormComponentSelector),
			dateSelector,
			wizardDateFormat: dateFormat
		});

		//Adding custom validator for Date fields for when submit is clicked
		$(accountCommunicationFormComponentSelector).find(dateSelector).each((index, element) => {
			var $element = $(element);
			$element.attr("data-has-custom-validator", true).data({
				customValidator: () => {
					var errorMessages = [];
					var date = $element.val();

					if (date != null && date != "") {
						errorMessages = InputHelper.validateDates({
							dateFormat: dateFormat,
							date,
							dateInvalidMessage: window.FORM_VALIDATION_MESSAGES.INVALID_DATE,
						}) || [];
					}

					return {
						errorMessages,
						isValid: !errorMessages.length
					};
				}
			});
		});
	},

	serializeNumbers: function ($accountCommunicationFormComponent) {
		var numbers = InputHelper.getGeneralInputValues(
			$accountCommunicationFormComponent.find(numberSelector)
		);

		return numbers.filter(number => !!number.type && !!number.value);
	},

	clearCommunicationForm: function ($accountCommunicationFormComponent) {
		// Clear all form field values
		$accountCommunicationFormComponent.find(nonCheckableFieldsSelector).val("");

		// Reapply any select components' default values
		var $selectComponentsWithDefaults = $accountCommunicationFormComponent.find("[data-component='select'][data-code-type-default-value]");
		$selectComponentsWithDefaults.each((index, element) => {
			var defaultValue = $(element).attr("data-code-type-default-value") || "";
			$(element).find("select").val(defaultValue);
		});

		// Reset Radio Buttons, Single, and Multi Checkboxes
		$accountCommunicationFormComponent.find(checkableFormFieldsSelector).prop("checked", false);
	},

	_getEventOrReturn: function (event, isDesignModeMessage) {
		return ActionsHelper.getEventOrReturn(event, AccountStore.get("isDesignMode"), isDesignModeMessage);
	}
};

module.exports = AccountCommunicationsHelper;
